import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { OperationOverlaySmallDialogComponent } from './operation-overlay-small-dialog/operation-overlay-small-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Injectable()
export class OperationOverlaySmallService {
    constructor(private fiDialogsService: FiDialogsService) {}

    openOperationOverlaySmallDialog(
        contentComponent: IOperationOverlaySmallDialogContentComponentRef,
        dialogData: IOperationOverlaySmallDialogData,
    ) {
        const panelClass = ['operation-overlay-small-panel'];
        if (dialogData.cssClass) {
            panelClass.push(dialogData.cssClass);
            delete dialogData.cssClass;
        }
        const d = Object.assign({}, dialogData, {
            contentData: {
                component: contentComponent,
                data: dialogData,
            },
        });
        const config: MatDialogConfig<IOperationOverlaySmallDialogData> = {
            panelClass: panelClass,
            data: d,
        };
        return this.fiDialogsService.open(OperationOverlaySmallDialogComponent, config);
    }
}

export interface IOperationOverlaySmallDialogData {
    cssClass?: string;
    contentData?: IOperationOverlaySmallDialogContentData;
}

export interface IOperationOverlaySmallDialogContentData {
    component?;
    data;
}

export interface IOperationOverlaySmallDialogContentComponentRef {
    new (...args: any[]);
}
